import { useNavigate } from 'react-router-dom';

interface FacilityModalProps {
  onClose: () => void;
}

export default function FacilityModal({ onClose }: FacilityModalProps) {
  const navigate = useNavigate();

  const handleYes = () => {
    onClose();
    navigate('/services');
    setTimeout(() => {
      const el = document.getElementById('facility-form-section');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleNo = () => {
    onClose();
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('private-pay-form');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  const benefits = [
    { icon: 'ri-shield-check-line', text: 'Priority scheduling for your residents' },
    { icon: 'ri-price-tag-3-line', text: 'Preferred launch pricing for founding partners' },
    { icon: 'ri-team-line', text: 'Dedicated facility coordinator assigned to you' },
    { icon: 'ri-calendar-check-line', text: 'Flexible recurring & on-demand scheduling' },
  ];

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center px-4 py-6 overflow-y-auto">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg z-10 overflow-hidden my-auto">

        {/* Header Banner */}
        <div className="bg-gradient-to-br from-slate-900 via-black to-slate-800 px-8 pt-8 pb-6 text-center relative">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_80%,rgba(234,179,8,0.12),transparent_70%)]"></div>
          <div className="relative w-14 h-14 bg-yellow-500 rounded-xl flex items-center justify-center mx-auto mb-4">
            <i className="ri-handshake-line text-black text-2xl"></i>
          </div>
          <h2 className="relative text-2xl font-bold text-white mb-2">
            Partner With Guardian Veterans
          </h2>
          <p className="relative text-white/60 text-sm leading-relaxed">
            Join our network of trusted healthcare facilities and give your residents reliable, dignified medical transportation.
          </p>
        </div>

        {/* Benefits */}
        <div className="px-8 py-6">
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">
            What facility partners receive
          </p>
          <div className="grid grid-cols-1 gap-3 mb-6">
            {benefits.map((b, i) => (
              <div key={i} className="flex items-center gap-3 bg-slate-50 rounded-xl px-4 py-3">
                <div className="w-8 h-8 flex items-center justify-center bg-yellow-100 rounded-lg flex-shrink-0">
                  <i className={`${b.icon} text-yellow-600 text-base`}></i>
                </div>
                <span className="text-sm text-slate-700 font-medium">{b.text}</span>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="flex items-center gap-3 mb-5">
            <div className="flex-1 h-px bg-slate-200"></div>
            <span className="text-xs text-slate-400 font-medium">Who are you?</span>
            <div className="flex-1 h-px bg-slate-200"></div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col gap-3">
            <button
              onClick={handleYes}
              className="w-full py-4 bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-base rounded-xl transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-building-line text-lg"></i>
              I represent a healthcare facility
            </button>
            <button
              onClick={handleNo}
              className="w-full py-4 bg-slate-900 hover:bg-slate-800 text-white font-bold text-base rounded-xl transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-user-line text-lg"></i>
              I need personal transportation
            </button>
          </div>

          <button
            onClick={onClose}
            className="mt-4 w-full text-xs text-slate-400 hover:text-slate-600 transition-colors cursor-pointer"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
